export { default } from './Percentage'
